import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { User } from './types/User';

export type UpdateUserPayload = Partial<
  Omit<User, 'spokenLanguages'> & {
    spokenLanguages: string;
  }
>;

export type userIdType = number | 'me';

const updateUser = (makeCall: MakeCall) => (
  userId: userIdType,
  data: UpdateUserPayload,
) =>
  makeCall<User>('PUT', `${APIV2_URL}/user/${userId}`, {
    data,
  });

export default updateUser;
